import { Icons } from '@/components/icons';
import {
  defaultBooleanFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  defaultStringFilter,
  defaultTagFilter,
  type Filter,
} from '@/components/table-filters/constants';
import { OrganizationUserConfig, RoleConfig } from '@pigello/pigello-matrix';

const organizationUserFilters: Filter[] = [
  {
    ...defaultStringFilter,
    title: OrganizationUserConfig.fields.communicationName.verboseName,
    externalFieldName:
      OrganizationUserConfig.fields.communicationName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: OrganizationUserConfig.fields.corporateName.verboseName,
    externalFieldName:
      OrganizationUserConfig.fields.corporateName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: OrganizationUserConfig.fields.email.verboseName,
    externalFieldName: OrganizationUserConfig.fields.email.externalFieldName,
  },
  {
    ...defaultBooleanFilter,
    title: OrganizationUserConfig.fields.emailVerified.verboseName,
    externalFieldName:
      OrganizationUserConfig.fields.emailVerified.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: OrganizationUserConfig.fields.phoneNumber.verboseName,
    externalFieldName:
      OrganizationUserConfig.fields.phoneNumber.externalFieldName,
  },
  {
    ...defaultBooleanFilter,
    title: OrganizationUserConfig.fields.phoneNumberVerified.verboseName,
    externalFieldName:
      OrganizationUserConfig.fields.phoneNumberVerified.externalFieldName,
  },
  {
    ...defaultSelectFilter,
    title: OrganizationUserConfig.fields.detailAccess.verboseName,
    externalFieldName:
      OrganizationUserConfig.fields.detailAccess.externalFieldName,
    choices: OrganizationUserConfig.fields.detailAccess.choices,
  },
  {
    ...defaultRelationFilter,
    title: OrganizationUserConfig.fields.role.verboseName,
    externalFieldName: OrganizationUserConfig.fields.role.externalFieldName,
    relationModelName: RoleConfig.modelName,
    icon: Icons.user,
  },
  // {
  //   title: OrganizationUserConfig.fields.workEngagements.verboseName,
  //   externalFieldName:
  //     OrganizationUserConfig.fields.workEngagements.externalFieldName,
  //   relationModelName: WorkEngagementConfig.modelName,
  //   ...defaultRelationFilter,
  // },
  {
    ...defaultStringFilter,
    title: OrganizationUserConfig.fields.username.verboseName,
    externalFieldName: OrganizationUserConfig.fields.username.externalFieldName,
  },
  {
    ...defaultTagFilter,
    title: 'Taggar',
    externalFieldName: 'tags',
    relationModelName: 'tag',
    icon: Icons.tag,
  },
  {
    ...defaultTagFilter,
    title: 'Exkludera taggar',
    externalFieldName: 'tags_exclude',
    relationModelName: 'tag',
    icon: Icons.tag,
  },
];

export default organizationUserFilters;
